<template>
  <header-one class="pa-0" title="Glossary">
    <div class="text-xs-left text-md-right">
      <v-btn
        outlined
        small
        color="primary"
        class="expand-btn glossary__index-btn"
        @click="handleDownload"
      >
        {{ 'Download glossary' }}
        <v-icon v-if="!isDownloadingPdf" color="primary" class="donwload-icon">
          mdi-download
        </v-icon>
        <v-icon
          v-if="isDownloadingPdf"
          color="primary"
          class="donwload-icon spinner-icon"
        >
          mdi-autorenew
        </v-icon>
      </v-btn>
      <v-btn
        outlined
        small
        color="primary"
        class="expand-btn glossary__index-btn"
        @click="$emit('expand-all')"
      >
        {{ isExpandAll ? 'Expand all' : 'Collapse all' }}
      </v-btn>
    </div>
  </header-one>
</template>

<script>
import { GlossaryApi } from '@gslc/models';
import HeaderOne from '../../components/typography/header-title-1.vue';
import { handleDownloadFile } from '../../utils/misc';
import { openApiConfig } from '../../api/config';
import { mapGetters } from 'vuex';

const config = openApiConfig();
const glossaryApi = new GlossaryApi(config);
export default {
  components: {
    HeaderOne,
  },
  props: {
    isExpandAll: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    isDownloadingPdf: false,
  }),
  methods: {
    async fetchGlossaryFiles() {
      const accessToken = await this.$auth.getTokenSilently();
      const file = await glossaryApi
        .getGlossaryFiles({
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .catch(e => console.error(e));
      return file?.data?.data?.file;
    },
    async handleDownload() {
      this.isDownloadingPdf = true;
      const file = await this.fetchGlossaryFiles();
      await handleDownloadFile(file);
      this.isDownloadingPdf = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.expand-btn {
  text-transform: capitalize;
  margin: 0 0.3125rem;
}
.glossary__index-btn {
  background-color: white;
  font-weight: 900;
  border-width: 0.15rem;
}
.donwload-icon {
  font-size: 14px;
  font-weight: 200;
  margin-left: 0.5em;
}
.spinner-icon {
  animation: spin-animation 1s infinite;
  animation-timing-function: linear;
  font-weight: 400 !important;
}
@keyframes spin-animation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
